module.exports = __webpack_public_path__ + "1a4302489e38c6d43413139c01ba98cb.MP3";